<div class="main-content-container">
  <div class="main-container-body">
    @if (otSlots && otSlots.bannerJson) {
      <div class="patient-card">
        <app-resource-banner [bannerJson]="otSlots.bannerJson" (patientResult)="getPatientData($event);">
        </app-resource-banner>
      </div>
    }
    <!-- <div class="container-title">
    <div class="d-flex align-items-center">
      <div class="pl-2 pr-2">
        <a class="d-inline-flex" href="javascript:void(0)" (click)="previous()">
          <img _ngcontent-lww-c11="" src="assets/images/grid-back.png">
        </a>
      </div>
      <h3 class="mb-0 text-capitalize">{{otSlots.scheduling}}</h3>
      <h3 class="mb-0 text-capitalize">{{otSlots.rescheduling}}</h3>
    </div>
  </div> -->

  <div class="page-title flex-grow-1 ng-star-inserted">
    <div class="mb-2 ng-star-inserted">
      <div class="d-flex align-items-center">
        <div class="pl-2 pr-2 ng-star-inserted"><a class="d-inline-flex" (click)="previous()"
          href="javascript:void(0)"><img src="assets/images/grid-back.png"></a></div>
          <div class="text-capitalize"> {{otSlots.scheduling}} </div>
          <div class="text-capitalize"> {{otSlots.rescheduling}} </div>
        </div>
      </div>
    </div>

    <div class="main-container-body main-box-shadow form-container">
      <!-- <div class="my-3">
      <date-time-filter [startDateEnable]="true" [endDateEnable]="true"
        (sendPickerResult)="sendPickerResult($event)">
      </date-time-filter>
    </div> -->
    <!-- <div class="row"> -->
    @if (otSlots.serviceType_code == 'surgery') {
      <div class="block-heading-container ng-star-inserted">
        <div class="block-heading">Surgery Scheduling Details</div>
        <div class="headingline"></div>
      </div>
    }
    @if (otSlots.serviceType_code != 'surgery') {
      <div class="block-heading-container ng-star-inserted">
        <div class="block-heading">Package Scheduling Details</div>
        <div class="headingline"></div>
      </div>
    }
    <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <label for="department" id="department">Department</label>
      <select class="form-control" (change)="getSurgeryName(otSlots.department_id)"
        [(ngModel)]="otSlots.department_id" name="departmentData" [disabled]="otSlots.deptbtnDisabled">
        <option value="">--Select department--</option>
        @for (dept of otSlots.departmentList; track dept) {
          <option [value]="dept.id">{{dept.name}}</option>
        }
      </select>
    </div>
    @if (otSlots.serviceType_code == 'surgery') {
      <div
        class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label for="otSlots.surgeryName" id="otSlots.surgeryName">Surgery Name</label>
        <select class="form-control" [(ngModel)]="otSlots.serviceItemId" name="surgeryNameData"
          [disabled]="otSlots.surgerybtnDisabled">
          <option value="">--Select Surgery Name--</option>
          @for (surgery of otSlots.surgeryName; track surgery) {
            <option [value]="surgery.id">{{surgery.name}}
            </option>
          }
        </select>
      </div>
    }
    @if (otSlots.serviceType_code == 'package') {
      <div
        class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label for="otSlots.surgeryName" id="otSlots.surgeryName">Package Name</label>
        <select class="form-control" [(ngModel)]="otSlots.serviceItemId" name="surgeryNameData"
          [disabled]="otSlots.packagebtnDisabled">
          <option value="">--Select Package Name--</option>
          @for (package of otSlots.surgeryName; track package) {
            <option [value]="package.id">{{package.name}}
            </option>
          }
        </select>
      </div>
    }
    <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <label for="surgeonSpeciality" id="surgeonSpeciality">Surgeon Speciality</label>
      <select class="form-control" (change)="getSurgeonName(otSlots.surgeon_speciality_id)"
        [(ngModel)]="otSlots.surgeon_speciality_id" name="surgeonSpecialityData"
        [disabled]="otSlots.specialitybtnDisabled">
        <option value="">--Select Surgeon Speciality--</option>
        @for (speciality of otSlots.surgeonSpeciality; track speciality) {
          <option [value]="speciality.id">
          {{speciality.text != undefined ?speciality.text:speciality.display}}</option>
        }
      </select>
    </div>
    <div class="kx-control col-9 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <label for="surgeonName" id="surgeonName" style="display: contents !important;">Surgeon Name</label>
      <i class="fa fa-info-circle" style="color: rgb(103, 207, 241); margin-left: 5px;"
      (click)="getDoctorSlots()"></i>
      <select class="form-control"  (change)="onSurgeonChange(otSlots.doctor_id)"
        [(ngModel)]="otSlots.doctor_id" name="surgeonNameData">
        <option value="">--Select Surgeon Name--</option>
        @for (s of otSlots.surgeonData; track s) {
          <option [value]="s.id">{{s.display_name}}</option>
        }
      </select>
    </div>
  <!-- </div>
  <div class="row"> -->
    <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <label for="expectedDateandTime" id="expectedDateandTime">Expected Surgery Date Time</label>
      <!-- <input type="text" class="form-control" placeholder="Expected Surgery Date Time"
                    [(ngModel)]="otSlots.expected_surgery_date_time" name="expectedDateandTime" [disabled]="otSlots.
                    btnDisabled" /> -->
      <input type="text" disabled ngxDaterangepickerMd class="form-control choose-date"
        placeholder="Choose date" showCancel="true" [timePicker]="true" [singleDatePicker]="true"
        [locale]="locale" [(ngModel)]="otSlots.expected_surgery_date_time" [minDateNumber]="1"
        [opens]="'center'" [showDropdowns]="true" (datesUpdated)="onChange($event)" />
    </div>
    @if (otSlots.surgery_type == 'OT') {
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class="required" for="OT" id="OT">OT</label>
        <select class="form-control" (change)="getAppointsSlots(otSlots.currentDate, otSlots.OTId)"
          [(ngModel)]="otSlots.OTId" name="otSlots.OTId" required>
          <option value="">--Select OT--</option>
          @for (ot of OTName; track ot) {
            <option [value]="ot.id">{{ot.name}}</option>
          }
        </select>
      </div>
    }
    @if (otSlots.surgery_type == 'CathLab') {
      <div
        class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class="required" for="OT" id="OT">CathLab</label>
        <select class="form-control" (change)="getAppointsSlots(otSlots.currentDate, otSlots.OTId)"
          [(ngModel)]="otSlots.OTId" name="otSlots.OTId" required>
          <option value="">--Select CathLab--</option>
          @for (ot of OTName; track ot) {
            <option [value]="ot.id">{{ot.name}}</option>
          }
        </select>
      </div>
    }
    @if (otSlots.scheduling == 'Schedule Surgery/Package' && otSlots.request_type == 'Surgery') {
      <div
        class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label for="additionalsurgeryName" id="additionalsurgeryName">Additional Surgery Name</label>
        <kx-multiselect-dropdown [questions]="otSlots.question" name="otSlots.multisurgeryName" [controlName]=""
          [placeholder]="'Select item'" [data]="otSlots.datasource" [settings]="otSlots.defaultSetting"
          [disabled]="false" (onDropDownClose)="onDropDownClose()" (onDeSelect)="onItemDeSelect($event)"
          (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
        </kx-multiselect-dropdown>
      </div>
    }
    @if (careType != '') {
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label for="care_type">Care Type</label>
        <input class="form-control" id="care_type" name="care_type" [(ngModel)]="careTypeName" disabled>
      </div>
    }
    @if (otSlots.rescheduling && otSlots.serviceType_code == 'surgery') {
      <div
        class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label [ngClass]="rescheduleReasonRemarkMandate?'required':''" for="Reason" id="Reason">Reason</label>
        <select class="form-control" [(ngModel)]="otSlots.reschedule_reason" name="otSlots.reschedule_reason">
          <option value="">Select</option>
          @for (ot of otSlots.rescheduleReasons; track ot) {
            <option [value]="ot.name">{{ot.name}}</option>
          }
        </select>
      </div>
    }
    @if (otSlots.rescheduling && otSlots.serviceType_code == 'surgery') {
      <div
        class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label [ngClass]="rescheduleReasonRemarkMandate?'required':''" for="reschedule_remarks">Remarks</label>
        <input class="form-control" id="reschedule_remarks" placeholder="Remarks" name="reschedule_remarks"
          [(ngModel)]="otSlots.reschedule_remarks">
      </div>
    }
    @if (otSlots.OTId && otSlots.showAcknowledge) {
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" style="padding-top: 34px;"
        >
        <!-- <input type="checkbox" id="acknowledgedCheckox" name="acknowledgedCheckox"
        (click)="hasAcknowledged($event)">
        <label for="acknowledged" id="acknowledged">acknowledge</label> -->
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="customCheck" name="acknowledgedCheckox"
            (click)="hasAcknowledged($event,$event.target.checked)">
          <label class="custom-control-label" for="customCheck">Acknowledge</label>
        </div>
      </div>
    }
    <!-- ---------------------multislots selections---------------- -->
    @if (otSlots.OTId && otSlots.multipleSlots) {
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" style="padding-top: 34px;"
        >
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" [(ngModel)]="otSlots.multiSlotsCheck"
            id="multiSlotsCheck" name="multiSlotsCheck"
            (change)="getAppointsSlots(otSlots.currentDate, otSlots.OTId)">
          <label class="custom-control-label" for="multiSlotsCheck">Multiple Slot</label>
        </div>
      </div>
    }
    @if (otSlots.OTId && otSlots.multipleSlots && appService.getUniversalConfig('multi_care_type')) {
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" style="padding-top: 34px;"
        >
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="generalSlots" name="generalSlots"
            (click)="careType == 'prime'?generalSlots($event,$event.target.checked):primeSlots($event,$event.target.checked)">
          <label class="custom-control-label" for="generalSlots">{{careType == 'prime'?'General':'Prime'}}
          Slots</label>
        </div>
      </div>
    }
    <!-- <div *ngIf="otSlots.OTId" class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
    style="padding-top: 34px;">
    <button class="primary-btn btn-md" (click)="viewCalender()">View Calender<i class="fa fa-calendar ml-2"
    aria-hidden="true"></i>
  </button>
</div> -->
@if (showSlots) {
  <div>
    <date-time-filter [startDateEnable]="true" [endDateEnable]="true" [showHideDetails]="false"
      (sendPickerResult)="sendPickerResult($event)">
    </date-time-filter>
  </div>
}
@if (otSlots.slots && showTmeSlots && showSlots) {
  <div class="py-3">
    <time-slots [duration]="otSlots.surgeryGradeDurationMin" [multipleSlots]="otSlots.multiSlotsCheck"
      [slotTimingInfo]="otSlots.slotTimingInfo" [slots]="otSlots.slots" [key]="'slot_start_time'"
      (slotResult)="slotResult($event)">
    </time-slots>
  </div>
}
@if (!otSlots.rescheduling) {
  <div>
    @if (otSlots.serviceType_code != 'package') {
      <div class="block-heading-container ng-star-inserted">
        <div class="block-heading">Surgery Criteria</div>
        <div class="headingline"></div>
      </div>
    }
    @if (otSlots.serviceType_code == 'package') {
      <div class="block-heading-container ng-star-inserted">
        <div class="block-heading">Package Criteria</div>
        <div class="headingline"></div>
      </div>
    }
    <div class="col-12">
      @if (resourceDef && otSlots.patientData) {
        <dhs-form [action]="'ADD'" [config]="formConfig"
          [data]="otSlots.patientData" [fieldGroup]="resourceDef.form" [decorator]="self"
          (questionValueChanged)="questionValueChanged($event)">
        </dhs-form>
      }
    </div>
    <div>
      <div class="block-heading-container ng-star-inserted">
        <div class="block-heading">Equipment Details</div>
        <div class="headingline"></div>
      </div>
      <app-ot-slots-view [patientInputData]="otSlots.patientData" [showButton]="false" [cArmInputArray]="cArmArray" (emitArray)="equipments($event)">
      </app-ot-slots-view>
    </div>
    <!-- <dhs-composite-array [current_action]="'ADD'" [item_key]="'doctor_id'"
    [items]="otSlots.billingComponent" [resource]="'schedule_surgeon_details'" [config]="config"
    [decorator]="self" (valueAdded)="eventFired($event);">
  </dhs-composite-array> -->
</div>
}
<!-- ---------------------------------------------------------- -->
<!-- </div> -->
@if (otSlots.serviceType_code == 'surgery' && otSlots.scheduling && !(otSlots.general_slots || otSlots.prime_slots)) {
  @if (showButton) {
    <div class="py-3 button-center" align="center" id="showButtons">
      <button class="primary-btn btn-md px-5" [disabled]="disabledButton"
      (click)="saveData()">Submit</button>
    </div>
  }
}
@if (otSlots.serviceType_code == 'surgery' && otSlots.scheduling && (otSlots.general_slots || otSlots.prime_slots)) {
  @if (showButton) {
    <div class="py-3 button-center" align="center" id="showButtons">
      <button class="primary-btn btn-md px-5" [disabled]="disabledButton"
      (click)="savePrimeData()">Submit</button>
    </div>
  }
}
@if (otSlots.serviceType_code == 'package' || (otSlots.serviceType_code == 'surgery' && otSlots.rescheduling  && !(otSlots.general_slots || otSlots.prime_slots))) {
  @if (showButton) {
    <div class="py-3 button-center" align="center" id="showButtons">
      <button class="primary-btn btn-md px-5" [disabled]="disabledButton"
      (click)="savePackageData()">Submit</button>
    </div>
  }
}
@if (otSlots.serviceType_code == 'surgery' && otSlots.rescheduling && (otSlots.general_slots || otSlots.prime_slots)) {
  @if (showButton) {
    <div class="py-3 button-center" align="center" id="showButtons">
      <button class="primary-btn btn-md px-5" [disabled]="disabledButton"
      (click)="savePrimeData()">Submit</button>
    </div>
  }
}
</div>
</div>
</div>